import { HolidayTypeModel } from "../models/HolidayTypeModel";
import { IHttpRequestService } from "./HttpRequestService";

export interface IHolidayTypeService {
    GetAllHolidayTypes(): Promise<HolidayTypeModel[]>;
    GetHolidayType(id: number): Promise<HolidayTypeModel>;
    Save(data: HolidayTypeModel): Promise<HolidayTypeModel | undefined>;
    Delete(id: number): Promise<boolean>;
}

export class HolidayTypeService implements IHolidayTypeService {
    constructor(private httpRequestService: IHttpRequestService) {}

    public async GetAllHolidayTypes(): Promise<HolidayTypeModel[]> {
        try {
            const url = `/api/v1/HolidayType`;
            const { data } = await this.httpRequestService.Get<HolidayTypeModel[]>(url);
            if(!data || data.length == 0) { return []; }
            return data as HolidayTypeModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }

    public async GetHolidayType(id: number): Promise<HolidayTypeModel> {
        try {
            const { data } = await this.httpRequestService.Get<HolidayTypeModel>(`/api/v1/HolidayType/${id}`);
            return data as HolidayTypeModel;
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return new HolidayTypeModel();
    }

    public async Save(data: HolidayTypeModel): Promise<HolidayTypeModel | undefined> {
        try {
            const response = data.id > 0
                ? await this.httpRequestService.Put<HolidayTypeModel, HolidayTypeModel>(`/api/v1/HolidayType/Update`, data)
                : await this.httpRequestService.Post<HolidayTypeModel, HolidayTypeModel>(`/api/v1/HolidayType/Add`, data);

            if (response) {
                return response as HolidayTypeModel;
            }
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return undefined;
    }

    public async Delete(id: number): Promise<boolean> {
        try {
            await this.httpRequestService.DeleteById<boolean>(`/api/v1/HolidayType/${id}`);
            return true;
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return false;
    }
}
